import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Form, Dropdown, Popup, Icon } from "semantic-ui-react";

import FormikAPIErrorMessage from "./FormikAPIErrorMessage.jsx";

import { getErrorStateFromProps } from "../formUtils.js";
import { omit } from "lodash";

class FormikSemanticDropdown extends PureComponent {
  static propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    apiErrors: PropTypes.object,
    label: PropTypes.string,
    help: PropTypes.string,
    placeholder: PropTypes.string
  };

  // -- HANDLERS -- //

  onBlur = (evt, data) => {
    const { onBlur, form } = this.props;
    form.setFieldTouched(data.name, true);
    if (onBlur) onBlur(evt, data, form);
  };

  onChange = (evt, data) => {
    const { onChange, form } = this.props;
    form.setFieldValue(data.name, data.value);
    if (onChange) onChange(evt, data, form);
  };

  // -- RENDER -- //

  renderHelpPopup() {
    const { help } = this.props;

    if (!help) return null;

    return (
      <Popup
        trigger={
          <Icon name="help circle" color="orange" className="float-right" />
        }
        content={help}
        position="top right"
        offset={[11, 0]}
        wide
      />
    );
  }

  render() {
    const {
      field,
      className,
      apiErrors,
      label,
      options,
      readOnly,
      disabled,
      required,
      width
    } = this.props;

    // set semantic-ui field error state
    const isError = getErrorStateFromProps(this.props);

    // needed to adjust field margin-bottom if error is shown
    let fullClassName = className || "";
    fullClassName = isError ? `${fullClassName} errored` : fullClassName;

    // props for for the generated input field
    const inputProps = {
      selection: true,
      selectOnBlur: false,
      selectOnNavigation: false,
      ...omit(this.props, "field", "form", "apiErrors", "label", "width"),
      ...field,
      onChange: readOnly ? null : this.onChange,
      onBlur: readOnly ? null : this.onBlur // Formik tries even if semantic is set not to
    };

    const labelId = `${inputProps.name}_label`;
    const isRequired = readOnly || disabled ? false : required;

    if (!readOnly) {
      return (
        <Form.Field
          required={isRequired}
          className={fullClassName}
          error={isError}
          width={width}
        >
          {this.renderHelpPopup()}
          {label && (
            <label htmlFor={field.name} id={labelId}>
              {label || null}
            </label>
          )}
          <Dropdown {...inputProps} aria-labelledby={labelId} />
          <FormikAPIErrorMessage name={field.name} apiErrors={apiErrors} />
        </Form.Field>
      );
    }

    const selected = options.filter(obj => {
      return obj.value === field.value;
    });
    const selectedText = selected[0] ? selected[0].text : "Not set";

    return (
      <Form.Field className={className}>
        {this.renderHelpPopup()}
        {label && <label htmlFor={field.name}>{label || null}</label>}
        <p>{selectedText}</p>
      </Form.Field>
    );
  }
}

export default FormikSemanticDropdown;
